import { useContext, useEffect, useState } from 'react';
import UserContext from '../contexts/UserContext';
import { useLocation, useNavigate } from 'react-router';
import { jwtDecode } from 'jwt-decode';
import { loginSuccess } from '../store/slices/authSlice';
import { useDispatch } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(UserContext);
  const [isAuthorized, setIsAuthorized] = useState(null); // null = loading, true = allow, false = deny
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const authId = queryParams.get('authid');
    let accessToken = '';
    // alert(authId)
    // Case 1: User is logged in
    if (isAuthenticated) {
      setIsAuthorized(true);
      return;
    }

    // Case 2: No authid and not logged in → redirect
    if (!authId) {
      redirectToLogin();
      return;
    }

    // Case 3: authid exists → validate
    const validateAuthId = async () => {
      try {
        // const res = await fetch(`/api/public-access/validate?auth=${authId}`);
        //const data = await res.json();
        const accessToken = new URLSearchParams(location.search).get('authid');
        if (accessToken !== undefined) {
          const decoded = jwtDecode(accessToken);
          // alert(JSON.stringify(decoded))
          let payload = {
            token: accessToken,
            data: decoded.data,
          };

          dispatch(loginSuccess(payload));
          localStorage.setItem('token', accessToken);
          const data = { valid: true };

          if (data?.valid) {
            setIsAuthorized(true); // allow access
          } else {
            redirectToLogin(); // invalid authid
          }
        }
      } catch (err) {
        redirectToLogin(); // API error
      }
    };

    validateAuthId();
  }, [isAuthenticated, location]);

  const redirectToLogin = () => {
    navigate('/login', {
      state: {
        pathname: location.pathname,
        search: location.search,
      },
    });
  };

  if (isAuthorized === null) return <div>Loading...</div>;

  return children;
};

const ProtectedRoute2 = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(UserContext);

  //   const verifyUserSessionIsActive = async () => {
  //     // Check if there is a token stored in local storage
  //     let token = localStorage.getItem('token');

  //     if (!token) {
  //       setLoggedInUser(null);
  //       navigate('/login', {
  //         state: {
  //           pathname: location.pathname,
  //           search: location.search,
  //         },
  //       });
  //     } else {
  //       try {
  //         const decodedToken = jwtDecode(token);
  //         setLoggedInUser({
  //           id: decodedToken?.id,
  //           name: decodedToken?.username,
  //         });

  //         navigate(location.pathname + location?.search, {
  //           state: { search: location.search },
  //         });
  //       } catch {
  //         navigate('/login', {
  //           state: {
  //             pathname: location.pathname,
  //             search: location.search,
  //           },
  //         });
  //       }
  //     }
  //   };

  useEffect(() => {
    // if (!loggedInUser) verifyUserSessionIsActive();
    if (isAuthenticated) {
      if (location.search) {
        navigate(location.pathname + location?.search, {
          state: { search: location.search },
        });
      }
      //   else {
      //     navigate('/');
      //   }
    } else {
      navigate('/login', {
        state: {
          pathname: location.pathname,
          search: location.search,
        },
      });
    }
  }, []);

  return children;
};

export default ProtectedRoute;
